import { render, staticRenderFns } from "./onlineExhibitionTopics.vue?vue&type=template&id=77974aaf&scoped=true"
import script from "./onlineExhibitionTopics.vue?vue&type=script&lang=js"
export * from "./onlineExhibitionTopics.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/onlineExhibitionTopics.css?vue&type=style&index=0&id=77974aaf&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77974aaf",
  null
  
)

export default component.exports